import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { bundleKeys } from "./bundle-keys";

/**
 * Fetch a single bundle (listing variant) with its components and
 * per-marketplace computed sellable. Disabled until `code` is set so the edit
 * modal can mount before a target is chosen.
 */
export function useBundle(code: string | null) {
  return useQuery({
    queryKey: bundleKeys.detail(code ?? ""),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/listings/{code}", {
        params: { path: { code: code as string } },
      });
      if (error) throw error;
      return data;
    },
    enabled: Boolean(code),
    staleTime: 30_000,
  });
}
